import type { FormStep, FormStepReview, FormStepReviewItem, ResolvedFormStep } from './types';
import { isReviewStep } from './types';
import type { SummarySectionProps, SummarySubsection } from './summary-section';

function resolveItemValue(item: FormStepReviewItem, values: Record<string, string>): string {
	if (item.format) return item.format(values);
	if (item.name) return values[item.name] ?? '';
	return '';
}

function resolveReviewConfig(
	review: NonNullable<FormStep['review']>,
	values: Record<string, string>
): FormStepReview {
	return typeof review === 'function' ? review(values) : review;
}

function mapSubsection(
	subsection: FormStepReview['subsections'][number],
	values: Record<string, string>
): SummarySubsection {
	return {
		title: subsection.title,
		columns: subsection.columns,
		items: subsection.items.map(item => ({
			title: item.label,
			value: resolveItemValue(item, values),
			span: item.span,
		})),
	};
}

export function buildReviewSections(
	steps: ReadonlyArray<FormStep | ResolvedFormStep>,
	values: Record<string, string>,
	goToStep: (index: number) => void
): SummarySectionProps[] {
	const sections: SummarySectionProps[] = [];

	steps.forEach((step, index) => {
		if (isReviewStep(step.stepTitle) || !step.review) return;

		const review = resolveReviewConfig(step.review, values);

		sections.push({
			title: review.title ?? step.stepTitle,
			onEditClick: () => goToStep(index),
			columns: review.columns,
			subsections: review.subsections.map(subsection => mapSubsection(subsection, values)),
		});
	});

	return sections;
}
